import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/public/Bits";

export function ProtectedRoute({ children }) {
  const { admin } = useAuth();
  if (admin === null) return <div className="min-h-screen bg-ukf-canvas"><Loader label="Checking session…" /></div>;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}
